import { create, useModal } from '@ebay/nice-modal-react';
import { t } from 'i18next';
import { useState } from 'react';

import useMxCookies from 'modules/Authentication/hooks/useMxCookies';
import ConfirmationPopup from 'modules/ConfirmationPopup/ConfirmationPopup';
import { authLogger } from 'utils/logging/scopedLogger';
import { clearAllIndexedDB } from 'utils/matrixUtils';

const DeleteSessionPopup = create(() => {
  const { remove } = useModal(DeleteSessionPopup);
  const { clearCookies } = useMxCookies();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      authLogger.info('User confirmed session deletion, clearing cookies and indexedDB, reloading page');
      clearCookies();
      await clearAllIndexedDB();
      remove();
      authLogger.info('Reloading page after session deletion');
      window.location.reload();
    } catch (error) {
      authLogger.error('Error during session deletion', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ConfirmationPopup onClose={remove} isVisible>
      <div className="flex flex-col text-size-sm items-center space-y-2 p-2">
        <p className="text-black text-center mb-2 font-medium">{t('unable_to_restore_session')}</p>
        <p className="text-gray-80">{t('session_deletion_explanation')}</p>
      </div>
      <ConfirmationPopup.Footer>
        <ConfirmationPopup.Button variant="secondaryTertiary" onClick={() => window.location.reload()}>
          {t('reload_page')}
        </ConfirmationPopup.Button>
        <ConfirmationPopup.Button
          variant="destructive"
          onClick={handleConfirm}
          disabled={isLoading}
          loading={isLoading}
        >
          {t('clear_storage')}
        </ConfirmationPopup.Button>
      </ConfirmationPopup.Footer>
    </ConfirmationPopup>
  );
});

export default DeleteSessionPopup;
